import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";

export const StudentWelcomeEmailDialog = ({ open, setOpen, school, users }) => {
  const ApiClient = useApiClient();
  const allUsers = users?.length === 0;
  // Unverified users
  const sendEmails = async () => {
    try {
      const result = await ApiClient.users.sendStudentWelcomeEmails({
        school: allUsers ? school?.id : null,
        users: allUsers ? [] : users.map((user) => user.id),
      });
      if (result.success) {
        enqueueSnackbar(result.message, {
          variant: "success",
          autoHideDuration: 3000,
        });
        handleClose();
      } else {
        enqueueSnackbar(result.message, {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("There was a problem sending the emails", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"md"}>
      <DialogTitle>Send welcome emails</DialogTitle>
      <DialogContent>
        {allUsers
          ? "This will send welcome emails to all students at the school who have not yet received one"
          : "Sending welcome email to selected users"}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button variant={"contained"} onClick={sendEmails}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};
